Backbone = require 'backbone'
Backbone.$ = $

class EmailFormIntlTextParagraphView extends Backbone.View
  tagName: 'li'

  initialize: (options) ->
    @options = options || {}
    @model = @options.model
    @label = @model.label
    @isFlexibleStepThree = @options.isFlexibleStepThree
    @base_template = @options.template
    @template = {text_paragraph_template: true}
    @isInputCompulsory = @model.required is true or @model.required is "true"

  render: ->
    @$el.html(toHtml(@base_template, @toHash()))

  toHash: ->
    labels = @label.split('\\n')
    textLines = []
    _.each(labels, (label, index)->
      textLines[index]={}
      textLines[index].text = label
    )
    hash =
      required: @isInputCompulsory
      stepThreeType: if @isFlexibleStepThree then 'flexibleStepThree' else 'defaultStepThree'
      counter: @model.counter
      labels: textLines
    _.extend @template, hash

  isInputGiven: ->
    true

  isInputValid: ->
    true

  populateInput:(data) ->
    data

  validateEmailForm: ()->
    @options.validateEmailForm()

module.exports = EmailFormIntlTextParagraphView
